module.exports = __webpack_public_path__ + "static/img/about2_3.fd419b7e.jpg";